module.exports = __webpack_public_path__ + "img/hr-level1_mining_tool-2.d95c3d49.png";